/*
 * air-tens.js — native behaviour for the converted pulsio-eu Tens PDP.
 * Replaces the Replo runtime for the interactions this product page uses:
 *   1. Add-to-cart: visible [data-replo-add-product-variant-to-cart] button
 *      submits the hidden native <form action="/cart/add"> in its product
 *      container (keeps the add-to-cart CTA working with no runtime).
 *   2. Collapsible accordions ([data-replo-collapsible]) — toggle hidden content,
 *      aria-expanded and data-state (drives the +/- icon).
 *   3. Colour swatches ([role="option"]) — visual aria-selected toggle.
 *   4. Carousels (review/media sliders) — transform-based prev/next/dots/drag.
 *   5. Sleek-style scroll reveals + the Replo alchemy-fade "invisible section"
 *      fix (paused opacity:0 keyframes resumed / overridden on intersection).
 * No external dependencies; idempotent per element; safe to load once.
 */
(function () {
  if (window.__airTensInit) return;
  window.__airTensInit = true;

  var TRANSITION = 'transform 450ms cubic-bezier(0.22, 0.61, 0.36, 1)';
  var DRAG_THRESHOLD = 10;
  var REVEAL_OPTS = { rootMargin: '0px 0px -8% 0px', threshold: 0.15 };
  var STAGGER_MS = 80;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function sections() {
    return document.querySelectorAll('[id^="replo-section-"]');
  }

  /* ---------------------------------------------------------------- ATC --- */
  function initAddToCart(scope) {
    var btns = (scope || document).querySelectorAll(
      '[data-replo-add-product-variant-to-cart]'
    );
    Array.prototype.forEach.call(btns, function (btn) {
      if (btn.__airAtc) return;
      btn.__airAtc = true;
      btn.style.cursor = 'pointer';
      btn.addEventListener('click', function (e) {
        if (btn.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          return;
        }
        var container =
          btn.closest('[data-replo-product-container]') ||
          btn.closest('[id^="replo-section-"]');
        if (!container) return;
        var form = container.querySelector('form[action*="/cart/add"]');
        if (!form) return;
        e.preventDefault();
        // native submit → full-page POST to /cart/add (redirects to /cart)
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    });
  }

  /* -------------------------------------------------------- accordions --- */
  function initAccordions(scope) {
    var items = (scope || document).querySelectorAll('[data-replo-collapsible]');
    Array.prototype.forEach.call(items, function (item) {
      if (item.__airAcc) return;
      item.__airAcc = true;
      var trigger = item.querySelector('[aria-controls]');
      if (!trigger) return;
      var content = document.getElementById(
        trigger.getAttribute('aria-controls')
      );

      function setOpen(open) {
        item.setAttribute('data-state', open ? 'open' : 'closed');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (content) {
          if (open) content.removeAttribute('hidden');
          else content.setAttribute('hidden', '');
        }
      }
      setOpen(item.getAttribute('data-state') === 'open');
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        setOpen(trigger.getAttribute('aria-expanded') !== 'true');
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setOpen(trigger.getAttribute('aria-expanded') !== 'true');
        }
      });
    });
  }

  /* ----------------------------------------------------------- swatches --- */
  var SWATCH_SELECTED = {
    'r-1dh5zc6': 'r-1b7y8m1',
    'r-17x28k0': 'r-z6gz3f',
  };

  function readVariantData() {
    var el = document.getElementById('air-tens-variant-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function containerOf(el) {
    return el.closest('[data-replo-product-container]') || document;
  }

  function formOf(scope) {
    return (scope.querySelector ? scope : document).querySelector(
      'form[action*="/cart/add"], form[data-type="add-to-cart-form"]'
    );
  }

  function setFormVariant(scope, id) {
    var form = formOf(scope);
    if (!form || !id) return;
    var input = form.querySelector('input[name="id"]');
    if (input) input.value = id;
  }

  function swatchSelectedClass(opt) {
    var classes = (opt.className || '').split(/\s+/);
    for (var i = 0; i < classes.length; i++) {
      if (SWATCH_SELECTED[classes[i]]) return SWATCH_SELECTED[classes[i]];
    }
    for (var j = 0; j < classes.length; j++) {
      if (classes[j].indexOf('r-') === 0 && classes[j] !== 'r-1dh5zc6' && classes[j] !== 'r-17x28k0') {
        return classes[j];
      }
    }
    return null;
  }

  function setSwatchVisual(opts, active) {
    Array.prototype.forEach.call(opts, function (opt) {
      var on = opt === active;
      opt.setAttribute('aria-selected', on ? 'true' : 'false');
      var selectedClass = swatchSelectedClass(opt);
      if (selectedClass) opt.classList.toggle(selectedClass, on);
    });
  }

  function updateColourLabel(container, value) {
    if (!value) return;
    var label = container.querySelector('.r-cowgbd span, .r-cowgbd');
    if (label) label.textContent = value;
  }

  function imageUrlWithWidth(url, width) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', String(width));
      return u.href;
    } catch (e) {
      return url;
    }
  }

  function imageKey(url) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      return u.pathname.split('/').pop().split('?')[0].toLowerCase();
    } catch (e) {
      return String(url).toLowerCase();
    }
  }

  function setPictureSources(picture, url) {
    if (!picture || !url) return;
    picture.style.setProperty('--replo-attributes-currentitem', url);
    var img = picture.querySelector('img.r-tmtqqy, img');
    if (img) img.src = url;
    Array.prototype.forEach.call(picture.querySelectorAll('source'), function (source) {
      var media = source.getAttribute('media') || '';
      var width = 1800;
      if (media.indexOf('max-width: 640px') !== -1) width = 820;
      else if (media.indexOf('1024px') !== -1) width = 1024;
      source.srcset = imageUrlWithWidth(url, width);
    });
  }

  function updateGalleryImage(container, url) {
    if (!url || !container) return;
    var targetKey = imageKey(url);
    var carousel = container.querySelector('[data-replo-carousel]');
    if (carousel) {
      var slides = carousel.querySelectorAll('[data-replo-part="slide"]');
      var goTo = carousel.__airGoToSlide;
      if (slides.length && goTo) {
        for (var i = 0; i < slides.length; i++) {
          var img = slides[i].querySelector('img');
          if (img && imageKey(img.getAttribute('src') || img.src) === targetKey) {
            goTo(i);
            return;
          }
        }
        var stem = targetKey.replace(/\.[a-z0-9]+$/, '');
        for (var j = 0; j < slides.length; j++) {
          var slideImg = slides[j].querySelector('img');
          var slideKey = imageKey(slideImg && (slideImg.getAttribute('src') || slideImg.src));
          if (stem && slideKey.indexOf(stem) !== -1) {
            goTo(j);
            return;
          }
        }
        var active =
          carousel.querySelector('[data-replo-part="slide"][data-is-active="true"]') ||
          slides[0];
        setPictureSources(active.querySelector('picture.r-ysz4e3'), url);
        return;
      }
    }
    setPictureSources(container.querySelector('picture.r-ysz4e3'), url);
  }

  function initSwatches(scope) {
    var data = readVariantData();
    (scope || document).querySelectorAll('[data-replo-option-select]').forEach(function (listbox) {
      if (listbox.__airSwatch) return;
      listbox.__airSwatch = true;
      var opts = Array.prototype.slice.call(listbox.querySelectorAll('[role="option"]'));
      if (!opts.length) return;
      var container = containerOf(listbox);
      function select(opt, idx) {
        setSwatchVisual(opts, opt);
        if (data && data.optionValues && data.byValue) {
          var val = data.optionValues[idx];
          var id = val != null ? data.byValue[val] : null;
          if (id) setFormVariant(container, id);
          updateColourLabel(container, val);
          if (data.imageByValue && val != null && data.imageByValue[val]) {
            updateGalleryImage(container, data.imageByValue[val]);
          }
        }
        try {
          if (window.AirSoldOut) window.AirSoldOut.syncContainer(container);
        } catch (err) {}
      }
      var initiallySelected = -1;
      opts.forEach(function (opt, idx) {
        var handler = function (e) {
          if (e) e.preventDefault();
          select(opt, idx);
        };
        opt.style.cursor = 'pointer';
        opt.addEventListener('click', function (e) {
          handler(e);
          opt.blur();
        });
        opt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            handler(e);
            opt.blur();
          }
        });
        if (opt.getAttribute('aria-selected') === 'true') initiallySelected = idx;
      });
      if (initiallySelected >= 0) {
        try { select(opts[initiallySelected], initiallySelected); } catch (err) {}
      }
    });
  }

  /* ----------------------------------------------------------- carousel --- */
  function currentX(track) {
    var m = /translate3d\(\s*(-?[\d.]+)px/.exec(track.style.transform || '');
    return m ? parseFloat(m[1]) : 0;
  }
  function initCarousel(root) {
    if (window.AirCarousel && window.AirCarousel.init) {
      return window.AirCarousel.init(root);
    }
  }

  /* ------------------------------------------------------------- motion --- */
  function hasAlchemyPaused(el) {
    var cs = getComputedStyle(el);
    return cs.animationName && cs.animationName.indexOf('alchemy') !== -1 && cs.animationPlayState === 'paused';
  }
  function hasBackgroundImage(el) {
    if ((el.style.backgroundImage || '').indexOf('url') !== -1) return true;
    var cs = getComputedStyle(el);
    return cs.backgroundImage && cs.backgroundImage !== 'none';
  }
  function isInView(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh * 0.92 && r.bottom > 0;
  }
  function revealEl(el) {
    if (el.__airRevealed) return;
    el.__airRevealed = true;
    el.classList.remove('air-reveal-pending');
    el.classList.add('air-reveal-visible');
  }
  function tagReveal(el, variant, delayMs) {
    if (el.__airRevealTagged) return null;
    el.__airRevealTagged = true;
    el.setAttribute('data-air-reveal', variant || 'fade-up');
    if (delayMs) el.style.setProperty('--air-reveal-delay', delayMs + 'ms');
    el.classList.add('air-reveal-pending', 'air-reveal--' + (variant || 'fade-up'));
    if (reducedMotion || isInView(el)) { revealEl(el); return null; }
    return el;
  }
  function initAirMotion() {
    var toObserve = [];
    var alchemyBg = [];
    function observe(el) { if (el && !el.__airRevealed) toObserve.push(el); }

    Array.prototype.forEach.call(sections(), function (section) {
      section.querySelectorAll('[data-replo-carousel]').forEach(function (carousel) {
        if (hasAlchemyPaused(carousel) && hasBackgroundImage(carousel)) { alchemyBg.push(carousel); return; }
        observe(tagReveal(carousel, 'fade-up', 0));
      });
      // Trust badges / review widgets: gentle fade
      section.querySelectorAll('.trustpilot-widget').forEach(function (widget) {
        var wrap = widget.parentElement;
        if (!wrap || wrap.__airRevealTagged) return;
        observe(tagReveal(wrap, 'fade', 0));
      });
    });

    var nodes = document.querySelectorAll('[id^="replo-section-"] [data-rid]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.__airRevealTagged || node.closest('[data-replo-carousel]')) continue;
      if (!hasAlchemyPaused(node)) continue;
      if (hasBackgroundImage(node)) { alchemyBg.push(node); continue; }
      node.classList.add('air-reveal--alchemy-override');
      observe(tagReveal(node, 'fade-up', 0));
    }

    function playAlchemy(el) { el.style.animationPlayState = 'running'; }
    if (alchemyBg.length) {
      if (!('IntersectionObserver' in window) || reducedMotion) {
        alchemyBg.forEach(playAlchemy);
      } else {
        var aio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { playAlchemy(e.target); aio.unobserve(e.target); }
          });
        }, { rootMargin: '0px 0px -5% 0px', threshold: 0.01 });
        alchemyBg.forEach(function (el) { if (isInView(el)) playAlchemy(el); else aio.observe(el); });
      }
    }

    if (!toObserve.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) { toObserve.forEach(revealEl); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { revealEl(e.target); io.unobserve(e.target); }
      });
    }, REVEAL_OPTS);
    toObserve.forEach(function (el) { if (isInView(el)) revealEl(el); else io.observe(el); });
  }

  ready(function () {
    initAddToCart(document);
    initAccordions(document);
    Array.prototype.forEach.call(document.querySelectorAll('[data-replo-carousel]'), initCarousel);
    initSwatches(document);
    initAirMotion();
  });
})();
